import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import ShippingSkipPackingSelector from './ShippingSkipPackingSelector'
import * as Styles from './styles'

const PickingAndPackingSection = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('Recogida y empaquetado')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define si quieres que la pantalla de empaquetado se abra al preparar envíos – para poder marcar productos como empaquetados, partir envíos si fuera necesario, etc. – o si el control de la recogida y el empaquetado se hará fuera de Reveni.'
        )}
      </Text>
      <ShippingSkipPackingSelector value={value} onChange={onChange} />
    </Styles.Container>
  )
}

export default PickingAndPackingSection
